<template>
  <el-result title="帳戶狀態檢驗" subTitle="正在檢驗帳戶狀態，請稍等片刻">
    <template slot="icon">
      <i class="el-icon-loading" style="font-size: 60px;"></i>
    </template>
  </el-result>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  created() {
    //如果检测不到登陆状态就跳转到登陆页
    this.$nextTick(() => {
      if (!this.$store.getters.hasLogin) {
        this.$router.push("/login");
      }
    })
  },
}
</script>

<style lang="scss" scoped></style>